import { file, prop, required } from '@rxweb/reactive-form-validators';

export class MediaClientModel {

    @required()
    name: string;

    //Razon Social
    @required()
    legal_name: string;


    @prop({name: 'address'})
    address: any;
    @prop({name: 'client_id'})
    client_id: any;
    @prop({name: 'company_client_id'})
    company_client_id: any;
    @prop({name: 'email'})
    email: any;
    @prop({name: 'tax_id'})
    tax_id: Date;
    @prop({name: 'contact_name'})
    contact_name: Date;
    @prop({name: 'phone_number'})
    phone_number: Date;
    @prop({name: 'active'})
    active: Date;
    @prop({name: 'notes'})
    notes: Date;


}
